export const ACCEPTED_FILE_TYPES: Record<string, string> = {
  'application/msword': '.doc', // MS Word legacy

  // Documents
  'application/pdf': '.pdf', // PDF documents
  'application/rtf': '.rtf', // Rich Text Format
  // Spreadsheets
  'application/vnd.ms-excel': '.xls', // Excel legacy

  'application/vnd.ms-outlook': '.msg', // Outlook messages
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx', // Modern Excel
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx', // Modern Word

  'application/zip': '.zip',
  // Images (for scanned documents)
  'image/bmp': '.bmp', // BMP images
  'image/gif': '.gif', // GIF images
  'image/jpeg': '.jpeg', // JPEG images
  'image/jpg': '.jpg', // JPG images
  'image/png': '.png', // PNG images

  'image/tiff': '.tif,.tiff', // TIFF images (common for scans)
  // Email formats
  'message/rfc822': '.eml', // Email messages

  'text/csv': '.csv', // CSV files
  // HTML
  'text/html': '.html',

  // Text formats
  'text/plain': '.txt', // Plain text
};

/** Set of all accepted file extensions (lowercase, with leading dot) */
export const ACCEPTED_FILE_EXTENSIONS = new Set(
  Object.values(ACCEPTED_FILE_TYPES)
    .flatMap((exts) => exts.split(','))
    .map((ext) => ext.trim().toLowerCase()),
);

// Maximum file size (20MB)
export const MAX_FILE_SIZE = 20 * 1024 * 1024;

// Maximum file amount
export const MAX_FILE_AMOUNT = 15;

// Maximum combined size of all attachments on a single email (~15MB), kept below
// the typical 25MB email-provider send limit to leave headroom for encoding overhead.
export const MAX_TOTAL_ATTACHMENT_SIZE = 15 * 1024 * 1024;
